import React, { useEffect, useRef, useContext, useState } from "react";
import { Moments } from "../context/MomentsContextProvider";
import { Gallery } from "./Gallery";
import { Timeline } from "./Timeline";
import { DragThrow } from "./DragThrow";

const CanvasGallery = (props) => {
    const [_Timeline, setTimeline] = useState(null);
    const [_Gallery, setGallery] = useState(null);
    const [_DragThrow, setDragThrow] = useState(null);
    const canvasRef = useRef(null);
    const timelineRef = useRef(null);
    const momentsData = useContext(Moments);
    const [isDrag, setIsDrag] = useState(false);

    useEffect(() => {
        setGallery(new Gallery(props.isActive, props.isVertical, props.isLeft));
        setTimeline(new Timeline(props.isActive, props.isVertical, props.isLeft));
        setDragThrow(new DragThrow(props.isVertical));
    }, []);

    const onInit = () => {
        if (props.isVertical && props.isLeft) {
            _Gallery.init(momentsData.filteredMomentsLeft, momentsData.currentMomentIDLeft, _Timeline, momentsData.sortedAllMoments, momentsData.onLike, momentsData.filterLeft, momentsData.setFilterLeft, momentsData.filteredYears, momentsData.setCurrentMomentIDLeft);
            _Timeline.init(momentsData.currentDateLeft, momentsData.filteredYearsLeft, _Gallery);
        } else if (props.isVertical && !props.isLeft) {
            // console.log("FILTERED MOMENTS RIGHT LENGTH: ", momentsData.filteredMomentsRight);
            _Gallery.init(momentsData.filteredMomentsRight, momentsData.currentMomentIDRight, _Timeline, momentsData.sortedAllMoments, momentsData.onLike, momentsData.filterRight, momentsData.setFilterRight, momentsData.filteredYears, momentsData.setCurrentMomentIDRight);
            _Timeline.init(momentsData.currentDateRight, momentsData.filteredYearsRight, _Gallery);
        } else {
            // console.log("FILTERED MOMENTS LENGTH: ", momentsData.filteredMoments);
            _Gallery.init(momentsData.filteredMoments, momentsData.currentMomentID, _Timeline, momentsData.sortedAllMoments, momentsData.onLike, momentsData.filter, momentsData.setFilter, momentsData.filteredYears, momentsData.setCurrentMomentID, momentsData.isLikeView);
            _Timeline.init(momentsData.currentDate, momentsData.filteredYears, _Gallery);
            _Gallery.isMonthView = true;
        }
    };

    const onInitYearView = (onFilterChange) => {
        // _YearView.init(momentsData.filteredMoments, momentsData.currentMomentID, momentsData.filteredYears);
        if (!props.isVertical) {
            _Gallery.initYearView(momentsData.filteredMoments, momentsData.currentMomentID, _Timeline, momentsData.filter, momentsData.setFilter, momentsData.filteredYears, props.selectYearTransition, onFilterChange);
            _Gallery.isMonthView = false;
            console.log("TODO: INIT YEAR VIEW");
        }
    };

    useEffect(() => {
        const updateTimer = [null];
        if (!props.isVertical) {
            console.log(" UPDATING FILTER IN GALLERY DEFAULT VIEW");
            if (_Gallery) {
                _Gallery.compareModeTransition();
                updateTimer[0] = setTimeout(() => {
                    if (_Gallery) {
                        if (props.isMonthView) {
                            onInit();
                        } else {
                            const onFilterChange = true;
                            onInitYearView(onFilterChange);
                        }
                    }
                }, 400);
            }
        }
        return () => {
            clearTimeout(updateTimer[0]);
        };
    }, [momentsData.filteredMoments, momentsData.isLikeView]);

    useEffect(() => {
        if (props.isVertical && _Gallery) {
            console.log("updating likes");
            _Gallery.syncLikes(momentsData.likedMoments);
        }
    }, [momentsData.likedMoments]);

    useEffect(() => {
        const updateTimer = [null];
        if (props.isVertical && props.isLeft) {
            if (_Gallery) {
                _Gallery.compareModeTransition();
                updateTimer[0] = setTimeout(() => {
                    if (_Gallery) {
                        onInit();
                    }
                }, 400);
            }
        }
        return () => {
            clearTimeout(updateTimer[0]);
        };
    }, [momentsData.filteredMomentsLeft]);

    useEffect(() => {
        const updateTimer = [null];
        if (props.isVertical && !props.isLeft) {
            console.log(" UPDATING FILTER IN GALLERY RIGHT");
            if (_Gallery) {
                _Gallery.compareModeTransition();
                updateTimer[0] = setTimeout(() => {
                    if (_Gallery) {
                        onInit();
                    }
                }, 400);
            }
        }
        return () => {
            clearTimeout(updateTimer[0]);
        };
    }, [momentsData.filteredMomentsRight]);

    // useEffect(() => {
    //     if (_Gallery && props.isVertical) {
    //         _Gallery.syncroniseLikedMoments(momentsData.likedMoments);
    //     }
    // }, [momentsData.likedMoments]);

    useEffect(() => {
        if (props.willUpdate && _Gallery) {
            if (props.isMaster) {
                momentsData.setCurrentMomentID(_Gallery.current.id);
                momentsData.setCurrentDate(_Gallery.current.date);
            }
            _Gallery.compareModeTransition();
        }
    }, [props.willUpdate]);

    useEffect(() => {
        if (_Gallery) {
            _Gallery.isActive = props.isActive;
            _Timeline.isActive = props.isActive;

            onInit();
        }
    }, [props.isActive]);

    useEffect(() => {
        const updateTimer = [null];
        if (props.isMaster) {
            console.log("> Transition between YEAR & MONTH view");
            if (_Gallery) {
                if (props.isMonthView) {
                    _Gallery.compareModeTransition();
                } else {
                    _Gallery.yearModeTransition();
                }
                updateTimer[0] = setTimeout(() => {
                    if (props.isMonthView) {
                        onInit();
                    } else {
                        momentsData.setCurrentMomentID(_Gallery.current.id);
                        momentsData.setCurrentDate(_Gallery.current.date);
                        onInitYearView();
                    }
                }, 400);
            }
        }
        return () => {
            clearTimeout(updateTimer[0]);
        };
    }, [props.isMonthView]);

    useEffect(() => {
        if (canvasRef.current && _Gallery && canvasRef.current && _Gallery) {
            _Gallery.canvas = canvasRef.current;
            _Timeline.canvas = timelineRef.current;
            _DragThrow.target = _Gallery;

            if (props.isMonthView || props.isVertical) {
                onInit();
            } else {
                onInitYearView();
            }
        }
    }, [canvasRef, _Gallery, timelineRef, _Timeline]);

    const onWheel = (e) => {
        _Gallery.scroll(e.deltaX, e.deltaY);
    };
    const onScroll = (e) => {
        e.preventDefault();
    };
    const touchStart = (e) => {
        if (!isDrag) setIsDrag(true);
        if (e.changedTouches[0]) {
            _DragThrow.startDrag(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        }
    };
    const touchMove = (e) => {
        if (isDrag) {
            _DragThrow.onDrag(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
        }
    };
    const touchEnd = (e) => {
        if (isDrag) {
            setIsDrag(false);
            _DragThrow.throw(e);
        }
    };
    const mouseDown = (e) => {
        e.preventDefault();
        if (!isDrag) setIsDrag(true);
        _DragThrow.startDrag(e.clientX, e.clientY);
    };
    const mouseMove = (e) => {
        if (isDrag) {
            _DragThrow.onDrag(e.clientX, e.clientY);
        } else {
            _Gallery.handleMouseMove(e);
        }
    };
    const mouseLeave = (e) => {
        if (isDrag) {
            setIsDrag(false);
            _DragThrow.throw(e);
        }
    };
    const mouseUp = (e) => {
        e.preventDefault();
        if (isDrag) {
            setIsDrag(false);
            _DragThrow.throw(e);
        }
    };

    return (
        //
        props.isVertical ? (
            <>
                <canvas className={`timeline`} ref={timelineRef} />
                <canvas className={`gallery`} ref={canvasRef} onWheel={onWheel} onScroll={onScroll} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd} onMouseDown={mouseDown} onMouseMove={mouseMove} onMouseLeave={mouseLeave} onMouseUp={mouseUp} />
            </>
        ) : (
            <>
                <canvas className={`gallery`} ref={canvasRef} onWheel={onWheel} onScroll={onScroll} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd} onMouseDown={mouseDown} onMouseMove={mouseMove} onMouseLeave={mouseLeave} onMouseUp={mouseUp} />
                <canvas className={`timeline`} ref={timelineRef} />
            </>
        )
        //
    );
};

export default CanvasGallery;
